/**
 * Résolution des URL d'API et WebSocket à l'EXÉCUTION.
 *
 * Ordre de priorité :
 *   1. Variable de build `VITE_*` si fournie (override explicite).
 *   2. **Même origine** quand on n'est pas en local → en prod, l'app est servie
 *      derrière Nginx sur `https://<domaine>` ; l'API (`/api`) et le WebSocket
 *      (`/ws/tracking`) sont proxifiés sur la MÊME origine. On évite ainsi le
 *      piège classique du fallback `localhost:8080` (mixed-content bloqué en
 *      HTTPS → carte/temps réel vides en production).
 *   3. `localhost:8080` en développement local.
 *
 * `wss://<même-hôte>` est autorisé par la CSP `connect-src 'self'`.
 */
function isLocalHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1'
}

/** Base de l'API REST (sans le suffixe `/api`). '' ⇒ même origine. */
export function apiBaseUrl(): string {
  const env = import.meta.env.VITE_API_BASE_URL
  if (env) return env
  if (typeof window === 'undefined') return 'http://localhost:8080'
  if (isLocalHost(window.location.hostname)) return 'http://localhost:8080'
  return '' // même origine → baseURL "/api"
}

/** URL complète du WebSocket de suivi (inclut `/ws/tracking`). */
export function wsUrl(): string {
  const env = import.meta.env.VITE_WS_URL
  if (env) return env
  if (typeof window === 'undefined') return 'ws://localhost:8080/ws/tracking'
  const { protocol, host, hostname } = window.location
  if (isLocalHost(hostname)) return 'ws://localhost:8080/ws/tracking'
  return `${protocol === 'https:' ? 'wss' : 'ws'}://${host}/ws/tracking`
}
